import React, {useContext} from 'react'

export type ReportsDockContextProps = {
  id: string
  prefix: string
  extended: boolean
  setExtended: (extended: boolean) => void
}

const ReportsDockContext = React.createContext<ReportsDockContextProps>(null as any)

export default ReportsDockContext

export function useReportsDockContext() {
  return useContext(ReportsDockContext)
}
